<template>
	<div class="w-full flex flex-col items-center gap-4 px-4">
		<p class="text-center mb-0">
			AQUI VOCÊ PODE IMPORTAR E EXPORTAR OS PROCEDIMENTOS DA ORGANIZAÇÃO.
		</p>
		<div class="w-full">
			<div class="w-full flex items-center gap-3 my-2">
				<!-- Area de exportacao -->
				<div
					class="w-6/12 card bg-light rounded-lg border-no overflow-hidden"
				>
					<p
						class="my-2 text-center font-weight-bold text-dark font-20"
					>
						EXPORTAÇÕES
					</p>
					<div
						class="select-card with-border my-2 py-1 px-2 mr-1"
						@click="OpenModal()"
					>
						<label class="">
							<div
								class="w-full rounded-lg d-flex justify-content-center"
							>
								<p class="mb-0">NOVA EXPORTAÇÃO</p>
							</div>
						</label>
					</div>
					<div style="height: 40vh; overflow-y: auto">
						<div
							v-if="GetProceedingsMovements('e') == 0"
							class="mh-200 text-muted d-flex justify-content-center align-items-center"
						>
							<span> NÃO HÁ NENHUM ARQUIVO AQUI </span>
						</div>
						<div
							v-for="proceedings_movement in GetProceedingsMovements(
								'e'
							)"
							:key="proceedings_movement.id"
						>
							<div class="border rounded-lg my-2 py-1 px-2 mr-1">
								<div class="col d-flex justify-content-between">
									<span
										>EXPORTAÇÃO #{{
											proceedings_movement.id
										}}</span
									>
									<span>{{
										ParseDate(
											proceedings_movement.created_at
										)
									}}</span>
									<a
										v-if="
											proceedings_movement.url &&
											!proceedings_movement.in_progress
										"
										v-tippy="{ arrow: true }"
										class="px-1"
										content="Fazer download"
										@click="
											DownloadFile(
												proceedings_movement.url
											)
										"
									>
										<i class="fa fa-download"></i>
									</a>
									<span
										v-else-if="
											proceedings_movement.status ==
											'queued'
										"
										v-tippy="{ arrow: true }"
										content="Arquivo na fila de processamento"
									>
										<i class="fas fa-clock"></i>
									</span>
									<span
										v-else-if="
											proceedings_movement.status ==
											'executing'
										"
										v-tippy="{ arrow: true }"
										:content="
											'Gerando arquivo: ' +
											(proceedings_movement.progress_percentage >
											100
												? 99
												: proceedings_movement.progress_percentage) +
											'%'
										"
									>
										<span
											class="spinner-border spinner-border-sm mt-2"
											role="status"
											aria-hidden="true"
										></span>
									</span>
									<span
										v-else-if="
											proceedings_movement.status ==
												'failed' ||
											proceedings_movement.status ==
												'retrying' ||
											(proceedings_movement.status ==
												'finished' &&
												!proceedings_movement.url)
										"
										v-tippy="{ arrow: true }"
										content="Houve uma falhar ao gerar o arquivo..."
									>
										<i
											class="fas fa-exclamation-circle text-danger"
										></i>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Area de importacao -->
				<div
					class="w-6/12 card bg-light rounded-lg border-no overflow-hidden"
				>
					<p
						class="my-2 text-center font-weight-bold text-dark font-20"
					>
						IMPORTAÇÕES
					</p>
					<div
						class="select-card with-border my-2 py-1 px-2 mr-1"
						:disabled="HasPendingProgress()"
						@click="ImportProceedings()"
					>
						<label class="">
							<div
								class="w-full rounded-lg d-flex justify-content-center"
							>
								<p class="mb-0">NOVA IMPORTAÇÃO</p>
							</div>
						</label>
					</div>
					<div style="height: 40vh; overflow-y: auto">
						<div
							v-if="GetProceedingsMovements('i') == 0"
							class="mh-200 text-muted d-flex justify-content-center align-items-center"
						>
							<span> NÃO HÁ NENHUM ARQUIVO AQUI </span>
						</div>
						<div
							v-for="proceedings_movement in GetProceedingsMovements(
								'i'
							)"
							:key="proceedings_movement.id"
						>
							<div class="border rounded-lg my-2 py-1 px-2">
								<div class="col d-flex justify-content-between">
									<span
										>IMPORTAÇÃO #{{
											proceedings_movement.id
										}}</span
									>
									<span>{{
										ParseDate(
											proceedings_movement.created_at
										)
									}}</span>
									<a
										v-if="
											proceedings_movement.url &&
											!proceedings_movement.in_progress
										"
										v-tippy="{ arrow: true }"
										class="px-1"
										content="Fazer download"
										@click="
											DownloadFile(
												proceedings_movement.url
											)
										"
									>
										<i class="fa fa-download"></i>
									</a>
									<span
										v-else-if="
											proceedings_movement.status ==
											'queued'
										"
										v-tippy="{ arrow: true }"
										content="Arquivo na fila de processamento"
									>
										<i class="fas fa-clock"></i>
									</span>
									<span
										v-else-if="
											proceedings_movement.status ==
											'executing'
										"
										v-tippy="{ arrow: true }"
										:content="
											'Importando os dados: ' +
											proceedings_movement.progress_percentage +
											'%'
										"
									>
										<span
											class="spinner-border spinner-border-sm mt-2"
											role="status"
											aria-hidden="true"
										></span>
									</span>
									<span
										v-else-if="
											proceedings_movement.status ==
												'failed' ||
											proceedings_movement.status ==
												'retrying' ||
											(proceedings_movement.status ==
												'finished' &&
												!proceedings_movement.url)
										"
										v-tippy="{ arrow: true }"
										:content="
											GetProceedingsMovementsFailMessage(
												proceedings_movement
											)
										"
									>
										<i
											class="fas fa-exclamation-circle text-danger"
										></i>
									</span>
								</div>
							</div>
						</div>
					</div>
					<input
						:id="'input-proceedings'"
						type="file"
						name=""
						accept=".xlsx"
						hidden
						@change="ImportProceedings($event)"
					/>
				</div>
			</div>
		</div>

		<div
			id="modal-export-proceedings"
			class="modal fade"
		>
			<div
				class="col modal-dialog d-flex justify-content-center align-items-center"
				@keydown.esc="CloseModal"
			>
				<div class="modal-content p-3 d-flex">
					<div class="align-self-end">
						<button
							id="close-modal"
							class="btn btn-light btn-sm m-2"
							@click="CloseModal"
						>
							<i class="fal fa-times"></i>
						</button>
					</div>
					<div class="modal-header mb-4">
						<h4 class="font-20 m-0 text-center">
							EXPORTAR PROCEDIMENTOS
						</h4>
					</div>
					<div
						class="modal-body d-flex flex-column align-items-center justify-content-start"
					>
						<div
							id="modules_and_modalities-dropdown"
							class="dropdown mb-2 mb-md-0 w-100 px-3"
						>
							<div
								class="pr-2 overflow-auto"
								style="max-height: 60vh"
							>
								<div
									class="d-flex flex-wrap flex-column modules-container"
								>
									<!-- <InputCheck
										v-model="
											filters.modules_and_modalities
												.select_all
										"
										input-id="select_all"
										input-name="select_all"
										text="SELECIONAR TUDO"
										:classes="{
											root: 'py-1',
											span: 'font-bold',
										}"
									/> -->

									<hr class="my-3" />

									<div class="dropdown-list">
										<div
											class="w-full px-0 hierarchy-select"
										>
											<HierarchySelect
												ref="hierarchySelect"
												:value="filters.modules"
												key-name="modules"
												identifier="module"
												:level="1"
												@change="ChangeFiltersHandler"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="modal-footer p-1">
						<button
							id="btn-export-proceedings"
							class="btn align-self-end mt-2 mb-0 mx-3 btn-primary"
							@click="ExportProceedings()"
						>
							EXPORTAR
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _, { split } from 'lodash'
	import Helpers from '../../../helpers'
	import moment from 'moment'
	import axios from 'axios'
	const helpers = new Helpers()

	import Swal from 'sweetalert2'
	import { mapGetters, mapActions } from 'vuex'
	export default {
		name: 'Proceedings',
		props: {
			providers: {
				type: Array,
				default: () => [],
			},
			organization: {
				type: Object,
				default: () => {},
			},
			permission: {
				type: Boolean,
				default: false,
			},
			can_modify: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				search: '',
				selected: {
					proceeding: null,
				},
				filters: {
					modules: [],
					// modules_and_modalities: {
					// 	module_1: {
					// 		id: 1,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_2: {
					// 		id: 2,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_3: {
					// 		id: 3,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_4: {
					// 		id: 4,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_5: {
					// 		id: 5,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_6: {
					// 		id: 6,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_7: {
					// 		id: 7,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_8: {
					// 		id: 8,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_9: {
					// 		id: 9,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	module_10: {
					// 		id: 10,
					// 		selected: false,
					// 		expanded: false,
					// 		modalities: [],
					// 	},
					// 	select_all: false,
					// },
				},
				input_clickable: true,
			}
		},
		computed: {
			...mapGetters('auth', [
				'account',
				'requester_selected_id',
				'update_current_url',
			]),
			...mapGetters('system', ['modules', 'modalities']),
			lib_schema() {
				return this.organization.instances[0].config.schema_name
			},
			parsed_modules() {
				return this.modules.map(module => {
					return {
						...module,
						modalities: this.modalities.filter(
							modality => modality.module_id == module.id
						),
					}
				})
			},
		},
		watch: {
			update_current_url: {
				handler(val) {
					if (val) {
						this.$parent.GetOrganizationData(false)

						this.UpdateCurrentUrl(false)

						this.$nextTick()
					}
				},
			},
			'filters.modules_and_modalities.select_all': {
				handler(val) {
					const modules_and_modalities = JSON.parse(
						JSON.stringify(this.filters.modules_and_modalities)
					)

					for (const [index, module] of Object.entries(
						modules_and_modalities
					)) {
						if (index != 'select_all') {
							this.filters.modules_and_modalities[
								index
							].selected = val

							if (val) {
								this.filters.modules_and_modalities[
									index
								].modalities = this.modalities
									.filter(m => m.module_id == module.id)
									.map(m => m.id)
							} else {
								this.filters.modules_and_modalities[
									index
								].modalities = []
							}
						}
					}
				},
			},
		},
		methods: {
			...mapActions('system', [
				'StartLoading',
				'FinishLoading',
				'GetModulesAndModalities',
			]),
			...mapActions('auth', ['UpdateCurrentUrl']),
			ModuleChangeHandler(event, module_id) {
				if (!event.target.checked) {
					this.filters.modules_and_modalities[
						`module_${module_id}`
					].modalities = []
				} else {
					if (
						!this.filters.modules_and_modalities[
							`module_${module_id}`
						].modalities.length
					) {
						this.filters.modules_and_modalities[
							`module_${module_id}`
						].modalities = this.modalities
							.filter(m => m.module_id == module_id)
							.map(m => m.id)
					}
				}
			},
			ModalityChangeHandler(event, modality_id) {
				const modality = this.modalities.find(m => m.id == modality_id)
				if (
					!this.filters.modules_and_modalities[
						`module_${modality.module_id}`
					].selected
				) {
					this.filters.modules_and_modalities[
						`module_${modality.module_id}`
					].selected = true
				}
			},
			GetProceedingsMovements(type) {
				return this.organization.proceedings_movements.filter(
					e => e.type == type
				)
			},
			ParseDate(date) {
				return moment(date).format('DD/MM/YYYY HH:mm')
			},
			HasPendingProgress() {
				let pendings = this.organization.proceedings_movements.filter(
					e => e.status == 'queued' || e.status == 'executing'
				)

				return pendings.length > 0
			},
			DownloadFile(url) {
				const method = 'GET'

				this.StartLoading()

				axios
					.request({
						url,
						method,
						responseType: 'blob',
					})
					.then(({ data }) => {
						const downloadUrl = window.URL.createObjectURL(
							new Blob([data], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							})
						)
						const link = document.createElement('a')
						link.href = downloadUrl
						link.setAttribute('download', '')
						document.body.appendChild(link)
						link.click()
						link.remove()
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			ExportProceedings() {
				if (this.HasPendingProgress()) {
					return Swal.fire({
						icon: 'info',
						toast: true,
						timer: 5000,
						position: 'top',
						html: 'Um procedimento já em andamento, aguarde.',
					})
				}

				this.StartLoading()

				const modules_and_modalities = JSON.parse(
					JSON.stringify(this.filters.modules_and_modalities)
				)

				this.filters.modalities = []

				for (const [index, module] of Object.entries(
					modules_and_modalities
				)) {
					if (index != 'select_all') {
						if (module.selected && !module.modalities.length) {
							module.modalities = this.modalities
								.filter(m => m.module_id == module.id)
								.map(m => m.id)
						}

						module.modalities.forEach(modality => {
							this.filters.modalities.push(modality)
						})
					}
				}

				return window.api
					.call('post', '/proceedings-movement/export/proceedings', {
						account_id: this.account.id,
						organization_id: this.organization.id,
						modalities: this.filters.modalities || [],
					})
					.then(({ data }) => {
						if (!data.response) {
							Swal.fire({
								icon: 'error',
								text: data.message,
								title: 'Ops!',
							})
						} else {
							Swal.fire({
								icon: 'info',
								title: 'Em andamento...',
								toast: true,
								position: 'top',
								html: `${data.message}`,
							})
						}

						this.CloseModal()
						this.$parent.GetOrganizationData()
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			ImportProceedings(event) {
				if (this.HasPendingProgress()) {
					return Swal.fire({
						icon: 'info',
						toast: true,
						timer: 5000,
						position: 'top',
						html: 'Um procedimento já em andamento, aguarde.',
					})
				}

				if (event && event.target.files.length > 0) {
					const file = event.target.files[0]

					this.StartLoading()

					const formData = new FormData()

					formData.append('file', file, file.name)
					formData.append('account_id', this.account.id)
					formData.append('organization_id', this.organization.id)

					return window.api
						.call(
							'post',
							'/proceedings-movement/import/proceedings',
							formData
						)
						.then(({ data }) => {
							if (!data.response) {
								Swal.fire({
									icon: 'error',
									text: data.message,
									title: 'Ops!',
								})
							} else {
								Swal.fire({
									icon: 'info',
									title: 'Ops!',
									text: `A importação ${data.proceedings_movement.id} foi para a fila de processamento.`,
								})

								this.$parent.GetOrganizationData()
							}

							document.querySelector('#input-proceedings').value =
								null
						})
						.finally(() => {
							this.FinishLoading()
						})
				}

				if (!this.input_clickable) return

				document.querySelector('#input-proceedings').click()
			},
			GetProceedingsMovementsFailMessage(proceedings_movement) {
				if (proceedings_movement?.job_status?.output?.message) {
					return (
						proceedings_movement.job_status.output.message.substring(
							0,
							100
						) + '...'
					)
				}

				return 'Não foi possível importar.'
			},
			OpenModal() {
				window.jQuery('#modal-export-proceedings').modal('show')

				window.jQuery('body').addClass('modal-open')

				window.jQuery('#modal-export-proceedings').addClass('d-flex')
			},
			CloseModal() {
				window
					.jQuery('#modal-export-proceedings')
					.modal('hide')
					.on('hidden.bs.modal', () => {
						window.jQuery('body').removeClass('modal-open')

						window
							.jQuery('#modal-export-proceedings')
							.removeClass('d-flex')
					})
			},
			NestModulesAndModalities() {
				return _.orderBy(this.modules, 'name', 'asc').map(module => {
					return {
						...module,
						modalities: _.orderBy(
							this.modalities,
							'name',
							'asc'
						).filter(modality => modality.module_id == module.id),
					}
				})
			},
			async StructFiltersHierarchyRecursively(hierarchy) {
				hierarchy = await Promise.all(
					hierarchy.map(async item => {
						const newItem = {
							id: item.id,
							name: item.name,
							selected: false,
							expanded: false,
							...this.GetCurrentStructure(item),
						}

						if (newItem.children) {
							newItem.children =
								await this.StructFiltersHierarchyRecursively(
									newItem.children
								)

							delete newItem[newItem.oldChildrenKey]
							delete newItem.oldChildrenKey
						} else {
							delete newItem.children
						}

						return newItem
					})
				)

				return hierarchy
			},
			GetCurrentStructure(item) {
				const current = {}

				if (item.modalities && Array.isArray(item.modalities)) {
					current.key = 'modules'
					current.children = item.modalities
					current.identifier = 'module'
					current.oldChildrenKey = 'modalities'
				} else {
					current.key = 'modalities'
					current.children = null
					current.identifier = 'modality'
				}

				return current
			},
			ChangeFiltersHandler() {},
		},
		async beforeMount() {
			await this.GetModulesAndModalities()
			this.filters.modules = await this.StructFiltersHierarchyRecursively(
				await this.NestModulesAndModalities()
			)
		},
	}
</script>

<style lang="css" scoped>
	.chevron-expand-container {
		position: absolute;
		right: 0;
		top: 0;
		width: 92%;
		height: 24.02px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: end;
	}

	.mh-138 {
		height: 138px;
		overflow: auto;
	}

	.fa-download {
		cursor: pointer;
	}

	.select-card label {
		padding-right: 1.5rem !important;
	}

	.dropdown-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		border: 1px solid var(--hr);
		border-bottom-left-radius: 0.5rem;
		border-bottom-right-radius: 0.5rem;
		overflow: hidden;
		padding: 0.3rem 0 0.3rem 0.75rem;
	}
</style>
